import Wrapper from "../../../layout/Wrapper";
import RiskVehicleContractReportComponent from "../../../screens/reports/riskVehicleContract";

import MetaComponent from "../../../components/common/MetaComponent";

const metadata = {
	title: "Risk Vehicle Contract Report",
	description: "",
};

export default function RiskVehicleContractReport() {
	return (
		<Wrapper>
			<MetaComponent meta={metadata} />
			<RiskVehicleContractReportComponent />
		</Wrapper>
	);
}